import React from 'react';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import { useRouteMatch } from 'react-router-dom';
import useStyles from './stepper.styles';
import { StepperComponentTypes, StepTypes } from './stepper.types';

import { ReactComponent as Step1Icon } from '../../../../assets/icons/Step1Icon.svg';
import { ReactComponent as Step2Icon } from '../../../../assets/icons/step2Icon.svg';
import { ReactComponent as Step3Icon } from '../../../../assets/icons/step3Icon.svg'
import { ReactComponent as CompleteIcon } from '../../../../assets/icons/CompleteIcon.svg';

const StepperComponent = (props: StepperComponentTypes) => {
  const classes = useStyles();
  const match = useRouteMatch();

  const CustomStepIcon = (props: any) => {
    const { active, completed, icon } = props;

    const StepIcons: { [key: number]: JSX.Element } = {
      1: <Step1Icon />,
      2: <Step2Icon />,
      3: <Step3Icon />,
    };

    if (completed) {
      return <CompleteIcon fill="green" />;
    }

    if (active) {
      return StepIcons[icon] ? React.cloneElement(StepIcons[icon], { fill: '#ffffff' }) : null;
    }
    return StepIcons[icon] || null;
  };

  const getActiveStep = () => {
    for (let i = 0; i < props.steps.length; i++) {
      const step = props.steps[i];
      if (step.path === match.path) return i;
    }
    return -1;
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={getActiveStep()} alternativeLabel>
        {props.steps.map((step: StepTypes) => (
          <Step key={step.title}>
            <StepLabel StepIconComponent={CustomStepIcon}>
              {step.title}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default StepperComponent;
